export const isFromIGCSEBuddy = () => {
  const url = new URL(window.location.href);
  const hostName = (url.hostname || '')
    .replace('.com', '')
    .replace('www.', '')
    .trim();

  return hostName === 'igcsebuddy';
};

export const getAppLogoUrl = (logoName: string) => {
  if (!logoName) return '';

  const igcseBuddyEnabled = isFromIGCSEBuddy();

  if (igcseBuddyEnabled) {
    return `${process.env.PUBLIC_URL}/images/igcsebuddy-logos/${logoName}`;
  }

  return `${process.env.PUBLIC_URL}/images/logos/${logoName}`;
};

export const getAppName = () => {
  const igcseBuddyEnabled = isFromIGCSEBuddy();

  if (igcseBuddyEnabled) {
    return 'IGCSE Buddy';
  }

  return 'Tutopiya';
};
